export default {
    en: {
        crowdgathering: 'Crowd Gathering Alert',
        faceControlRatio: '人脸布控比中',
        crowdRetention: 'Crowd Loitering Alert',
        crowded: 'Overcrowding Alert',
        crowdCountercurrent: 'Counterflow Alert',
        regionalInvasion: 'Regional Intrusion Alert',
        distanceTooClose: 'Social Distancing Alert',
        crowdSpreadOut: 'Crowd Dispersion Alert',
        areaOverLimit: 'Area Over-limit Alert',
        warningFace: 'Facial Matched Alert',
    },
    zh: {
        crowdSpreadOut: '人群分散告警',
        crowdgathering: '人群聚集告警',
        regionalInvasion: '区域入侵告警',
        distanceTooClose: '社交距离过近告警',
        crowdRetention: '人群滞留告警',
        crowded: '人群过密告警',
        crowdCountercurrent: '人群逆流告警',
        areaOverLimit: '区域人数超限报警',
        warningFace: '人脸布控告警',
    }
};
